<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
        <figure>
          <img class="finger-print" src="@/assets/images/fingerprints/fingerprint-nine.svg" alt="Lisa Bach">
        </figure>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Lisa Bach</h2>
      <p class="job-title"></p>


<p class="profile-statement-interviewer"> 
  Yolande Sumbele:
  The first question.
</p>

<p>
  Lisa Bach
  This stumbling block.
</p>

<p class="profile-statement-interviewer">
  Yolande Sumbele
  Yeah.
</p>

<p class="profile-statement-interviewer">
  Yolande Sumbele
  Well, I, I mean, I can't tell you about yourself.
</p>

<p class="profile-statement-interviewer">
  Yolande Sumbele
  But I guess UM.
</p>

<p class="profile-statement-interviewer">
  Yolande Sumbele
  It was just with Bernie in mind the fact that we're wanting to find out more about cultural identity and your sense of belonging. So within that question.
</p>

<p class="profile-statement-interviewer">
  Yolande Sumbele
  How could you tell us about yourself? With that in mind?
</p>

<p>
  Lisa Bach
  OK. Yeah. That makes more sense.
</p>

<p>
  Lisa Bach
  So uhm.
</p>

<p>
  Lisa Bach
  I am a half German, half Nepalese. My dad is German. My mom is Nepalese and I grew up in Nepal and I went to an English school there before I decided to come to Manchester to study.
</p>

<p>
  Lisa Bach
  to study and doing environmental degree. And since then I stayed at Manchester. Met uhm.
</p>

<p>
  Lisa Bach
  And I've worked on in various projects.
</p>

<p>
  Lisa Bach
  Now well.
</p>

<p>
  Lisa Bach
  Do I go into the professional bit?
</p>

<p>
  Yolande Sumbele
  I mean, yeah, you could, yeah.
</p>

<p>
  Lisa Bach
  Yep.
</p>

<button v-if="!showMore" @click="showMore = true" class="button is-large mb-6 show-more-btn">Show more</button>

<div v-if="showMore === true">

<p>
  Lisa Bach
  Uhm, so I started off in Arts and Humanities as a graduate intern, then moved on to a role where I was working predominantly in outreach and enrichment.
</p>

<p>
  Lisa Bach
  And then now I am the.
</p>

<p>
  Lisa Bach
  Alumni Relations officer and and throughout my time in my professional career at the university, I've worked very closely with students from a variety of backgrounds, and I've worked closely with widening participation where we've worked with.
</p>

<p>
  Yolande Sumbele
  So I guess #2 what inspires you within your role. I mean, you could also talk about your previous role if it links.
</p>

<p>
  Lisa Bach
  M.
</p>

<p>
  Lisa Bach
  In my previous role, uh once powered me was seeing students wanting to work within the community and to give back to the Community, particularly with the targeted schools we worked with. So we worked in areas as well.
</p>

<p>
  Lisa Bach
  One second.
</p>

<p>
  Lisa Bach
  Uh.
</p>

<p>
  Lisa Bach
  Yeah.
</p>

<p>
  Lisa Bach
  This is very good.
</p>

<p>
  Lisa Bach
  So students, won't you give back to the community?
</p>

<p>
  Lisa Bach
  See UM and wanting to kind of raise aspirations amongst, you know pupils or younger children, and currently in my role I now work with those students who are now recent grads who still want to give back to the student community and university and they volunteer their time, personal and professional advice, career opportunities and more. And I find that really inspirational, that they're giving up their time and their expertise.
</p>

<p>
  Lisa Bach
  To continuously raise aspirations.
</p>

<p>
  Yolande Sumbele
  I'm learning so much about. You ready?
</p>

<p>
  Yolande Sumbele
  I love it.
</p>

<p>
  Yolande Sumbele
  Three. What is something that you love about your culture or heritage?
</p>
<p>
  
  Lisa Bach
  I had kind of written on this already.
</p>

<p>
  Lisa Bach
  So I'm quite privileged that I have two cultures which are extremely different, so I've got the European side and the Asian side, but I would say having grown up in Nepal, I'm very, very proud of my Asian heritage, where I spent pretty much all my childhood. we have such an array of cultures, traditions, religions and growing up in an environment where everyone is very tolerant of all the various communities and beliefs is something I'm really proud of.
</p>

<p>
  Lisa Bach
  Uh and UM, Nepalese people are known for their hospitality as well.
  To look after your guests. So I'm very proud of that as well. And I like, I like to incorporate that into my life if I can.
</p>
<p>
  
  Yolande Sumbele
  How do you normally do that?
</p>

<p>
  Lisa Bach
  Oh, God. We've we feed them.
</p>

<p>
  Yolande Sumbele
  Stop them until they can't walk.
</p>

<p>
  Lisa Bach
  Exactly 1 portion is not enough.
</p>

<p>
  Yolande Sumbele
  I like that a moral duty of the end of the sets. I'm going to have a look at the transcription, but the moral duty like that, right?
</p>

<p>
  Lisa Bach
  Yeah, we we refer to them as gods, but I'd really don't want to say that.
</p>

<p>
  Yolande Sumbele
  Yep.
</p>

<p>
  Yolande Sumbele
  OK, so #4, what does it look like to bring your whole self to your work?
</p>

<p>
  Lisa Bach
  I think it means UM being authentic and true to yourself and be bringing all aspects of your being to your work, so this could include your passions, your interest, your personality, your family, and I think.
</p>

<p>
  Lisa Bach
  If it's in the correct environment, and you're supported to be your true self, then you know there is such a potential to flourish.
</p>

<p>
  Lisa Bach
  Uhm, I think everyone should.
</p>

<p>
  Lisa Bach
  Bring all aspects of themselves to work so that it celebrated, or you know you could even educate people on on something which are not aware of.
</p>

<p>
  Yolande Sumbele
  Education is key.
</p>

<p>
  Lisa Bach
  Yes.
</p>

<p>
  Yolande Sumbele
  And #5, how do you think mmu can best celebrate their black, Asian and minority ethnic?
</p>

<p>
  Yolande Sumbele
  Staff and students.
</p>

<p>
  Lisa Bach
  I think we should do more to celebrate the diverse backgrounds, cultures and faiths within the organization where such a large university with was it 35,000 students, I think 320,000 alum. I have no idea how many staff we have. Couple of 1000 staff as well and I think as a university we have such percent potential to provide a platform for people to gain an appreciation of each other.
</p>

<p>
  Lisa Bach
  Uh, you know, and valuing who they are as individuals and where they've come from.
</p>

<p>
  Lisa Bach
  Cool.
</p>

<p>
  Yolande Sumbele
  Like, yeah.
</p>

<p>
  Yolande Sumbele
  He said on the light.
</p>

<p>
  Yolande Sumbele
  And then the final question was, are you most proud of?
</p>

<p>
  Lisa Bach
  I'm proud to be included in the journey the university has been taking up around our.
</p>

<p>
  Lisa Bach
  You know, staff and students of colour and celebrating that, I've been involved in a few years now and just to see the difference in what we're doing and the acknowledgement of where we could go and the goals which we have, I'm proud of that. I'm really proud as well of UM, hosting a couple of BAME alumni panels and working with the BAME ambassadors. It's really heart-warming to see all the graduates and students getting involved.
</p>

<p>
  Lisa Bach
  In in conversations, which can be quite.
</p>

<p>
  Lisa Bach
  Sensitive or personal to them and for them to share that with us or with me in that situation, I I find that really inspirational.
</p>

<p>
  Yolande Sumbele
  Well, you have done so much, Lisa.
</p>

<p>
  Yolande Sumbele
  In your time here, I think you've you've been very, very, very active, clearly and.
</p>

<p>
  Lisa Bach
  I want to do more. We've not done our International Women's Day panel, which is really bugging me.
</p>

<p>
  Yolande Sumbele
  Oh yeah.
</p>

<p>
  Yolande Sumbele
  We were gonna do so was there not alternative dates and?
</p>

<p>
  Lisa Bach
  There's no student signups. That's a problem.
</p>

<p>
  Lisa Bach
  I'm getting. I'm getting no student engagement. Uhm, I wanted to and April, but everyones gone in April.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  So it's it's kind of like when, when when do we do it?
</p>

<p>
  Yolande Sumbele
  And may.
</p>

<p>
  Lisa Bach
  I don't think they're around.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  Unless you know of another another day for women that's coming up and we can do a bigger celebration.
</p>

<p>
  Yolande Sumbele
  I don't actually know of any days coming up, but I do know that the Union applied in to do a multicultural day where people wear different like outfits that represent their culture. So maybe as part of that the hype around that we could probably see if there could be an event that they also promotes as part of that day.
</p>

<p>
  Lisa Bach
  Uh, they?
</p>

<p>
  Lisa Bach
  Well, that's a great idea. Who's involved? That nisha.
</p>

<p>
  Yolande Sumbele
  So the teacher, student, Union president and Hanifa.
</p>

<p>
  Lisa Bach
  That's for sure.
</p>

<p>
  Yolande Sumbele
  It's well, he's the education.
</p>
<p>
  
  Yolande Sumbele
  Office staff.
</p>

<p>
  Lisa Bach
  Ah, good stuff, right?
</p>

<p>
  Yolande Sumbele
  Yeah. So they, they, they should just started working on it. So it's not really the plans on all in place yet, but it was something that we discussed, UM about 3-4 weeks ago.
</p>

<p>
  Lisa Bach
  OK, when do you know approximate date? They'd be. They'd be having that.
</p>
<p>
  
  Yolande Sumbele
  They didn't say day, they just said May.
</p>

<p>
  Lisa Bach
  May.
</p>

<p>
  Yolande Sumbele
  Uh, would you to have another catcher? UM last week, but there has to be cancelled, so I'll just find out if she has any further updates and I can let you know. I can include you in the email if if you prefer.
</p>

<p>
  Lisa Bach
  If you don't mind if you if you're asking for updates and just say, uhm, you know, International Women's Day unfortunately was postponed. So we're looking for for an alternative dates. So we've we've got the panelists ready.
</p>

<p>
  Yolande Sumbele
  Uh-huh.
</p>

<p>
  Lisa Bach
  So it's. I just, yeah. And the Union would be better at advertising and promoting it.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  And I think they'd appreciate, I mean, we've got someone from BBC.
</p>

<p>
  Yolande Sumbele
  OK.
</p>

<p>
  Lisa Bach
  So yeah, yeah, appoxee BBC. So she's she's a bit of a celebrity.
</p>

<p>
  Yolande Sumbele
  Really.
</p>

<p>
  Yolande Sumbele
  No.
</p>

<p>
  Yolande Sumbele
  Yeah, looks like today. Yeah. OK, I'll definitely let her know.
</p>
<p>
  
  Yolande Sumbele
  Yeah, at.
</p>

<p>
  Lisa Bach
  Yeah, they were ready to do it in person as well, so.
</p>

<p>
  Yolande Sumbele
  Oh wow.
</p>

<p>
  Yolande Sumbele
  'cause yeah, it would be nice if there's a multicultural day, but then there's an actual events that kind of rounds it all up at the end of the day, isn't it? So yeah.
</p>

<p>
  Lisa Bach
  It was all virtual.
</p>

<p>
  Yolande Sumbele
  Uhm, no. So it was just meant to be a time when they promote everyone you know, wearing something that is kind of cultural. And I'm not sure if they're planning any specific activities yet, but I was keen to the reason why I was involved in that conversation. 'cause I wanted it to be part of as I am in that we might go around taking pictures on that time and getting people to speak about, you know what they've actually done. UM, but I can. Yes, suggest the talk after it and then put you in contact with her.
</p>

<p>
  Lisa Bach
  Which just as I am also include graduates by any chance.
</p>

<p>
  Yolande Sumbele
  So Claire Ham Shire literally just mentioned that yesterday. That would be good to include alumni in.
</p>

<p>
  Lisa Bach
  OK, so uhm, this is going off piste. It's just 'cause. I've got a meeting about this on Thursday. We're actually discussing what to do with graduation because we will be there in person at the receptions. So this is this is where parents will be around and all that, and we're going to have a stand and we're looking for activities potentially to engage 'cause. We want their information because we need it for our database, but it would be good to have a hook.
</p>

<p>
  Yolande Sumbele
  Yes.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah, yeah. Yes, I I don't know what's in your stick, but.
</p>

<p>
  Lisa Bach
  And I saw, UM, something University of Manchester just had their graduation last week where it was just like, oh, you know, I'm I studied this and now I'm a nurse in whatever, especially for our 2020 cohort, because we're really struggling with engagement there.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  And we'll have them for three weeks.
</p>

<p>
  Lisa Bach
  And it'll have a little bit of champagne, so you can imagine how.
</p>

<p>
  Yolande Sumbele
  Wow.
</p>

<p>
  Lisa Bach
  Happy they will be.
</p>

<p>
  Yolande Sumbele
  Yes.
</p>

<p>
  Lisa Bach
  And we'll have some prizes so.
</p>

<p>
  Yolande Sumbele
  Well, So what? What actually is the event then?
</p>

<p>
  Lisa Bach
  So they'll have their ceremony at the Bridgewater hole, and then the and then they'll be hosting receptions at the Business School. So uh families and St well graduates at that point will be invited to come back and just have a bit of a drink and a cocktail. And, you know, just.
</p>

<p>
  Yolande Sumbele
  Uh-huh.
</p>

<p>
  Lisa Bach
  Just have fun. Celebrate.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah, yeah.
</p>

<p>
  Lisa Bach
  And then we'll have a started to kind of get them to sign up.
</p>
<p>
  
  Lisa Bach
  Ummm. But we were looking for some sort of activity to hook them in and and I think we don't do enough with our BME alum. To be honest. I think that's kind of why they brought me in.
</p>
<p>
  
  Yolande Sumbele
  Uh-huh.
</p>

<p>
  Lisa Bach
  But let's be honest.
</p>

<p>
  Lisa Bach
  And.
</p>

<p>
  Yolande Sumbele
  I mean, it says both purposes so.
</p>

<p>
  Lisa Bach
  So if you wanted to do as I am with the graduates.
</p>

<p>
  Lisa Bach
  That would be the perfect time to get them.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  'cause, we'll have our 2020 cohort for a week. There'll be some. I think there's about 5-6 hundred 2020 ones in there.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Wow.
</p>

<p>
  Lisa Bach
  And then all of our 2020 twos.
</p>

<p>
  Yolande Sumbele
  Wow. So it's gonna be huge. Oh, I see Aberdeen might be there as well. And she because she's graduating this year? Uhm.
</p>

<p>
  Lisa Bach
  Yeah.
</p>

<p>
  Lisa Bach
  And we'll have student champions as well on the desk. So we were looking for kind of getting our video content up. So I think I think we were looking to hire some student videographer's or maybe some professional people.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  But we kind of need a theme.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah, yeah, yeah.
</p>

<p>
  Lisa Bach
  So we could have our theme of where are you for, for the white students and then we could have as I am.
</p>

<p>
  Yolande Sumbele
  Uh-huh.
</p>

<p>
  Lisa Bach
  For non whites.
</p>

<p>
  Yolande Sumbele
  Because there's so many faces campaign as well, isn't there? So, you know, they could still be part of that 'cause many faces are looking for. UM, all diversity. Literally all drivers. That was people. So that could be something open to them. And then the specific thing for as I am, UM, we do have a videographer, photographer students as far so student photographer that we've hired. UM. So maybe if they're involved.
</p>

<p>
  Lisa Bach
  Ah.
</p>

<p>
  Yolande Sumbele
  If they would like to be, and if you think they'll be good enough, then right? Because for them to have that continuity working on a project in that way as well.
</p>

<p>
  Lisa Bach
  Three solid weeks, though, is a long time.
</p>

<p>
  Yolande Sumbele
  Yes, it is a long time, but how many days would it be? Oh yeah, there was the restricted to ours as well as in it. 'cause I only went out to work.
</p>

<p>
  Lisa Bach
  15 days.
</p>

<p>
  Lisa Bach
  Not not in July. They're not in term time then.
</p>

<p>
  Yolande Sumbele
  Oh yeah.
</p>

<p>
  Lisa Bach
  They could do. We could. We could basically try and get like two people and we share it between them up and then what we can do is we can train our student champions to ask the questions.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  So if we just have a set of questions and all we need to do is just have.
</p>

<p>
  Lisa Bach
  Just help them filmed, and then we'll we'll get their consent forms and all that kind of stuff as well.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  Uhm, we'll put it on our database and then you can just kind of.
</p>

<p>
  Lisa Bach
  Drag them in when you want and we'll keep it update on. Then we can flag them anyway you want really.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  That would be really great and thanks for thinking that idea. Such a helpful one. 'cause. There's so many students in there and it be really good to have experience.
</p>

<p>
  Lisa Bach
  Well, we're trying to think of what to do and it's like, do you want a hoodie? And I'm like, most boring, isn't it?
</p>

<p>
  Lisa Bach
  Give them some purpose.
</p>

<p>
  Yolande Sumbele
  Yeah, exactly. And for them to know that when they leave, there's still gonna be remembered at the university, which is a big thing.
</p>

<p>
  Lisa Bach
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah. OK, well.
</p>

<p>
  Lisa Bach
  Right. I'm gonna raise this on Thursday then.
</p>

<p>
  Yolande Sumbele
  Yes, I think you should.
</p>

<p>
  Yolande Sumbele
  And I'll I'll continue surfing while she raised that and I'm waiting for your response of, you know what, it's actually gonna happen or think if there's any specific activities or because of the Dave and Buster's, I think will still be working or at least a few of them. So maybe they might want to get involved in that as well with interviewing people for it if it's appropriate.
</p>

<p>
  Lisa Bach
  Yeah, well, yeah, that would work 'cause.
</p>

<p>Lisa Bach</p>
<p>Yeah, our champions are trained on at alumni benefits, so they could do that part and then the beam ambassadors could do the interviewing. And then we'll have the videographer, photographer just have a team of students just going for it.</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Yeah. Oh, they feel like real celebrities in their gowns and everything and be interviewed.
</p>

<p>
  Lisa Bach
  Exactly. And the parents will be there. This is why I'm like that. We can't miss this opportunity. 'cause. The parents will be like, go, go, go.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  So.
</p>

<p>
  Yolande Sumbele
  Yeah.
</p>

<p>
  Yolande Sumbele
  Even if they didn't want to. Yeah. It's respect your parents.
</p>

<p>
  Lisa Bach
  Yeah. Or like, you know, we could even interview the parents.
</p>

<p>
  Yolande Sumbele
  Yeah, it's true. It is true. Yeah. No. You're so right, though, because parents are huge. Part of, like, people, you know, feeling like the, the sense of belonging within university, as if their parents are happy. Then it makes you happy and less stress as well. So it's all a pipeline, isn't it?
</p>

<p>
  Lisa Bach
  Yeah.
</p>

<p>
  Lisa Bach
  Yeah. And I don't want to just focus on 1st Gen students. I want to work on all of them, really.
</p>

<p>
  Yolande Sumbele
  Oh, don't. Yeah, yeah, that's true.
</p>

<p>
  Lisa Bach
  How good? We have a plan.
</p>

<p>
  Yolande Sumbele
  Windy.
</p>

<p>
  Lisa Bach
  I was thinking I was racking my brains for Thursday. I was like, what are we gonna do?
</p>

<p>
  Yolande Sumbele
  It's a good plan. See, they're fine.
</p>

<p>
  Lisa Bach
  Yeah, we can share our budget.
</p>

<p>
  Yolande Sumbele
  Yes.
</p>

<p>
  Yolande Sumbele
  Because.
</p>

<p>
  Lisa Bach
  Which is another bonus.
</p>

<p>
  Yolande Sumbele
  It's true, St Money is again rising to it. Make a right thing.
</p>

<p>
  Yolande Sumbele
  He did in that shared their budgets, you.
</p>

<p>
  Lisa Bach
  Yeah, I think we could actually 'cause it's three solid weeks. Yeah, we definitely could.
</p>

<p>
  Yolande Sumbele
  Yeah, there we go.
</p>

<p>
  Yolande Sumbele
  Alright. Well, thank you. Again. Come. Yeah, and hopefully speak to you soon. Let me know how Thursday goes.
</p>

<p>
  Lisa Bach
  I will do a. Yeah, you're probably. You'll probably be pulled into a meeting with me and Laura, to be honest.
</p>
<p>
  
  Yolande Sumbele
  Yeah.
</p>

<p>
  Lisa Bach
  Oh, actually, that reminds me. Under do you know of anyone who would be good as an inspirational speaker at the graduation ceremonies?
</p>

<p>
  Lisa Bach
  Or.
</p>

<p>
  Lisa Bach
  We're also opening up our meetings to have spotlights on people. Would you like to come in and talk about ILC?
</p>

<p>
  Yolande Sumbele
  Oh, that's nice. UM, yes, I could do. I'd like to see. That would be nice.
</p>

<p>
  Yolande Sumbele
  Yes.
</p>

<p>
  Yolande Sumbele
  Uhm, I'll just say she wait because he's everywhere and he's everyone's inspirational speaker.
</p>
<p>
  
  Lisa Bach
  Yeah, but he's graduating his knee, so I can't really. I can't really pull him in. Maybe next year.
</p>

<p>
  Yolande Sumbele
  Oh yeah, that's tricky.
</p>

<p>
  Yolande Sumbele
  Yes, that's true.
</p>
<p>
  
  Yolande Sumbele
  I'll have a thing, a mic and ask.
</p>

<p>
  Yolande Sumbele
  Around to see maybe Cloud knows somebody who's been really good or some of them are operational working group can suggest anyone, but I'll I'll have a look around.
</p>

<p>
  Lisa Bach
  Uh-huh.
</p>

<p>
  Lisa Bach
  OK, I'll add you to the list of people to invite to our meetings.
</p>

<p>
  Yolande Sumbele
  OK. Thank you.
</p>

<p>
  Lisa Bach
  Alright.
</p>

<p>
  Yolande Sumbele
  See you. Bye.
</p>

<p>
  Lisa Bach
  Bye.
</p>

</div>


    </div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
  export default {

    setup() {
      const showMore = ref(false)

      return { showMore }
    }

  }
</script>

<style lang="scss" scoped>

  // .profile-container {
  // flex-direction: row-reverse;
  // }

  .profile-portrait-container {
    justify-content: flex-start;
  }

</style>